//Main Nav
(function($) { "use strict";

	$(".js-toggle-nav").click(function() { // Hamburger menu icon clicked
		$("body").toggleClass("js-nav-active"); //Toggle body class to reflect menu state
	});

})(jQuery);


// Hiding/showing main nav on scroll (Desktop)
(function($) { "use strict";

	// On page load
	var stOnload = $(document).scrollTop();
	
	if (stOnload <= 100) { // At the top

		// $('.main-nav__wrap').css("visibility", "visible");

	} else { // Away from the top

		// $('.main-header').addClass('js-nav-hidden');
		// setTimeout(function() {
		// 	$('.main-nav__wrap').css("visibility", "visible");
		// }, 2000);

	}

	// Hide bar on on scroll down
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	// var navbarHeight = $('.main-header').outerHeight();
	var triggerHeight = 5; //trigger hiding straight away

	$(window).scroll(function(event){
		didScroll = true;
	});

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 1000);


	function hasScrolled() {

		var st = $(document).scrollTop();

		// Make sure they scroll more than delta
		if(Math.abs(lastScrollTop - st) <= delta)
			return;

		// If they scrolled down, and past 'triggerHeight', hide the nav 
		if (st > lastScrollTop && st > triggerHeight){

			$('body').removeClass('js-nav-active').removeClass('js-nav-sticky');

		} else {
			// If they scrolled Up
			if(st + $(window).height() < $(document).height()) {
				$('body').addClass('js-nav-sticky');
			}
			// If they got back to the top, revert the nav
			if (st < lastScrollTop && st < triggerHeight) {
				$('body').removeClass('js-nav-sticky');
			}
		}

		lastScrollTop = st;
	}

})(jQuery);

